export function generateProductNameUrl(name){
    let nameArray = name.split(' ');
    
    let nameUrl = nameArray.join('-').toLowerCase();
    
    return nameUrl;
}

